var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page", attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("数字动画组件")]),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card d2-mb", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("只设置目标数字")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [_c("d2-count-up", { attrs: { end: 100 } })],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card d2-mb", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("设置起止数值")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [_c("d2-count-up", { attrs: { start: 14, end: 100 } })],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card d2-mb", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("小数位数")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [_c("d2-count-up", { attrs: { end: 100, decimals: 2 } })],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card d2-mb", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("动画时长")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [_c("d2-count-up", { attrs: { end: 100, duration: 6 } })],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("回调函数")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [
                      _c("d2-count-up", {
                        class: _vm.className,
                        attrs: {
                          end: 100,
                          callback: function() {
                            _vm.className = "end"
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "d2-card d2-mb-0", attrs: { shadow: "never" } },
                [
                  _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("结束一秒后更新数值")
                  ]),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [
                      _c("d2-count-up", {
                        attrs: { end: _vm.end, callback: _vm.update }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }